<div *ngIf="plant$ | async as plant;else loading">
    <h4 class="m-3">Plant name: {{plant.name}} </h4>
</div>
<ng-template #loading>
    <mat-progress-spinner color="primary" class="spinner-position" mode="indeterminate"></mat-progress-spinner>
</ng-template>